import { WorkflowSchedulerStage } from 'api-clients/monolith';
import produce from 'immer';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { SettingSwitch } from '../../../SettingSwitch';
import { messages } from '../messages';

interface SchedulerStageAllowRejectInGo {
  stage: WorkflowSchedulerStage;
  setStage: React.Dispatch<React.SetStateAction<WorkflowSchedulerStage>>;
}

export const SchedulerStageAllowRejectInGo: FC<
  SchedulerStageAllowRejectInGo
> = ({ stage, setStage }) => {
  const onToggle = () => {
    setStage(
      produce(stage, draftStage => {
        draftStage.allow_reject_in_go = !draftStage.allow_reject_in_go;
      }),
    );
  };

  return (
    <SettingSwitch
      dataKey="allow_reject_in_go"
      checked={Boolean(
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        stage.allow_reject_in_go ||
        stage.additional_info.use_go_hosts_for_interviewers,
      )}
      onChange={onToggle}
      disabled={Boolean(stage.additional_info.use_go_hosts_for_interviewers)}
      label={<FormattedMessage {...messages.allowRejectInHireGo} />}
    />
  );
};
